import React from 'react';
import './header.css';
import CTA from './CTA';
import HeaderSocials from './HeaderSocials';

const Header = () => {
  return (
    <header id='home'>
      <div className='header_container'>
        <h5>Hello, I'm</h5>
        <h1>Darius Williams</h1>
        <h5 className='text-light'>Cybersecurity Analyst | CompTIA Security+</h5>
        <p className='header_tagline'>
          Web Security Analyst at SiteLock, a Sectigo company. I clean malware from customer servers, analyze threats, and automate remediation for the team.
        </p>
        <CTA />
        <HeaderSocials />
      </div>
    </header>
  )
}

export default Header;
